import { deleteRequest, getRequest, postRequest, putRequest } from "../../apiClient";
import { LicensesEndpoint } from "../../apiEndpoints";

//#region----------------- GET-----------------------
export const GetLicenses = async (queryString: any) => {
    var _url = LicensesEndpoint.LICENSES_URL + (queryString ?? "");
    var res = await getRequest(_url);

    return res;
};

export const GetLicenseById = async (id: string | number) => {
    var _url = LicensesEndpoint.LICENSE_BY_ID_URL(id)
    var res = await getRequest(_url);

    return res;
};
//#endregion

//#region----------------- POST-----------------------
export const GenerateLicenseService = async (param: any) => {
    var _url = LicensesEndpoint.LICENSE_GENERATE_URL
    var res = await postRequest(_url, param);

    return res;
};
export const BuyLicenseService = async (param: any) => {
    var _url = LicensesEndpoint.LICENSE_BUY_URL
    var res = await postRequest(_url, param);

    return res;
};
export const BuyLicensePackageService = async (param: any) => {
    var _url = LicensesEndpoint.LICENSE_PACKAGE_BUY_URL
    var res = await postRequest(_url, param);

    return res;
};

export const AllocateLicenseService = async (id: string | number, param: any) => {
    var _url = LicensesEndpoint.LICENSE_ALLOCATE_URL(id)
    var res = await postRequest(_url, param);

    return res;
};
export const AssignLicenseService = async (id: string | number, param: any) => {
    var _url = LicensesEndpoint.LICENSE_ASSIGN_URL(id)
    var res = await postRequest(_url, param);

    return res;
};
export const GenerateLicenseInvoiceService = async (id: string | number) => {
    var _url = LicensesEndpoint.LICENSE_GENERATE_INVOICE_URL(id)
    var res = await postRequest(_url);

    return res;
};
//#endregion

//#region----------------- PUT-----------------------
export const EditLicenseService = async (id: string | number, param: any) => {
    var _url = LicensesEndpoint.LICENSE_BY_ID_URL(id);
    var res = await putRequest(_url, param);

    return res;
};
//#endregion

//#region----------------- DELETE-----------------------
export const InvalidateLicenseService = async (id: string | number) => {
    var _url = LicensesEndpoint.LICENSE_INVALIDATE_URL(id);
    var res = await deleteRequest(_url);

    return res;
};

export const DeleteLicenseService = async (id: string | number, param: any) => {
    var _url = LicensesEndpoint.LICENSE_DELETE_BY_ID_URL(id);
    var res = await postRequest(_url, param);

    return res;
};


//#endregion